import React from "react";
import ReactDOM from "react-dom";
import { logError, addContextLog } from "../../../infrastructure/log";
import TipNotification from "../../../app/components/tipNotification/TipNotification";
import { hideTipNotification } from "../../commons/hide-tip-notification";
import { translate } from "../../../infrastructure/translate/localization";

export function renderNotificationFileFilter({ message }) {
  const target = document.getElementById("notification-file-filter");
  if (target) {
    ReactDOM.render(
      <TipNotification
        message={message}
        handleClose={() => hideTipNotification("notification-file-filter")}
      />,
      target
    );
  }
}

export async function displayFileFilterNotification({
  state,
  employeeIds,
  filteredEmployees,
}) {
  try {
    addContextLog("info", "displayFileFilterNotification", "display-screen");
    if (state === "error" || employeeIds === 0) {
      return renderNotificationFileFilter({
        message: translate(
          "employees-section.filters-section.filter-file-error"
        ),
      });
    }
    if (employeeIds !== filteredEmployees) {
      return renderNotificationFileFilter({
        message: translate(
          "employees-section.filters-section.filter-file-warning",
          {
            numEmployees: employeeIds,
            numWarningEmployees: `${filteredEmployees - employeeIds}`,
          }
        ),
      });
    }
    return renderNotificationFileFilter({
      message: translate(
        "employees-section.filters-section.filter-file-success",
        { numEmployees: employeeIds }
      ),
    });
  } catch (e) {
    logError(e, "Error to displayFileFilterNotification");
    return null;
  }
}
